import { render, staticRenderFns } from "./NumericTextInput2.vue?vue&type=template&id=b4d66b52&scoped=true&"
import script from "./NumericTextInput2.vue?vue&type=script&lang=js&"
export * from "./NumericTextInput2.vue?vue&type=script&lang=js&"
import style0 from "./NumericTextInput2.vue?vue&type=style&index=0&id=b4d66b52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d66b52",
  null
  
)

export default component.exports